import API from "./index";

class ContratoService {
  constructor() {
    this.path = "api/contratos";
  }

  findAll({
            page = 1,
            size = 10,
            numeroContrato = "",
            tipoContratoId = null,
            contratadaId = null,
            situacao = null,
            excluido = null,
            objeto = null,
          }) {
    const params = { page: page - 1, size };

    if (numeroContrato) params.numeroContrato = numeroContrato;
    if (tipoContratoId !== null) params.tipoContratoId = tipoContratoId;
    if (contratadaId !== null) params.contratadaId = contratadaId;
    if (situacao) params.situacao = situacao;
    if (excluido !== null) params.excluido = excluido;
    if (objeto !== null) params.objeto = objeto;

    return API.get(this.path, { params });
  }

  findById(id) {
    return API.get(`${this.path}/${id}`);
  }

  create(data) {
    return API.post(this.path, data);
  }

  update(id, data) {
    return API.put(`${this.path}/${id}`, data);
  }

  delete(id) {
    return API.delete(`${this.path}/${id}`);
  }
}

export default new ContratoService();
